import { api } from "../../utils/api";

export const patchProfileDocuments = async (data) => {
    try {
        const response = await api.patch(`upload_my_documents`, data);
        return response.data;
      } catch (error) {
        throw new Error(error);
      }
}